var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentationChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "presentation-chart-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M24 32V42M24 32L36 42M24 32L12 42M42 6V22.4C42 25.7603 42 27.4405 41.346 28.7239C40.7708 29.8529 39.8529 30.7708 38.7239 31.346C37.4405 32 35.7603 32 32.4 32H15.6C12.2397 32 10.5595 32 9.27606 31.346C8.14708 30.7708 7.2292 29.8529 6.65396 28.7239C6 27.4405 6 25.7603 6 22.4V6M16 18V24M24 14V24M32 22V24M44 6H4",
    stroke: "#5732AB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationChart);
export default __webpack_public_path__ + "static/media/presentation_chart.3ab843b264f9075f711eb6b12cb3f357.svg";
export { ForwardRef as ReactComponent };